<template>
  <a-modal title="My Team"
           :visible="visible"
           width="90%"
           @ok="close"
           @cancel="close"
           style="top: 20px;"
           :cancel-button-props="{ style: { display: 'none' } }">
    <a-spin :spinning="loading">
      <a-row>
        <a-card hoverable v-if="showJefe">
          <a-card-meta>
            <a-spin slot="avatar" :spinning="jefeLoading">
              <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
              <a-avatar
                :src="profiles[jefe.id_person]"
              />
            </a-spin>
            <div slot="title">
              <img style="max-width: 20px; margin-top: -4px;"
                   :src="flags[jefe.nacionalidad]"
                   alt=""/>
              {{jefe.nombre}}
            </div>
            <div slot="description">
              <a-icon type="idcard" theme="twoTone"/>
              {{jefe.cargo}}
              <br/>
              <a-icon type="calendar" theme="twoTone"/>
              {{jefe.fecha_ingreso}}
              <br/>
              <template v-if="jefe.extra">
                <a-icon :type="jefe.extra_icon" style="color: red"/>
                {{jefe.extra}}
              </template>
            </div>
          </a-card-meta>
        </a-card>
      </a-row>
      <a-divider>MI EQUIPO DE TRABAJO</a-divider>
      <a-row :gutter="[16,16]">
        <a-col :sm="24" :md="8" v-for="persona in personas">
          <a-card hoverable class="fixed-card">
            <a-card-meta>
              <a-spin slot="avatar" :spinning="persona.loading !== false">
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
                <a-avatar :src="profiles[persona.id_person]"/>
              </a-spin>
              <div slot="title">
                <img style="max-width: 20px; margin-top: -4px;"
                     :src="flags[persona.nacionalidad]"
                     alt=""/>
                {{ persona.nombre }} {{ profileLoading[persona.id_person] }}
              </div>
              <div slot="description" class="card-content">
                <p>
                  <a-icon type="idcard" theme="twoTone"/>
                  {{ persona.cargo }}
                </p>
                <p>
                  <a-icon type="calendar" theme="twoTone"/>
                  {{ persona.fecha_ingreso }}
                </p>

                <!-- Espacio reservado aunque no haya información -->
                <p :class="{'hidden-info': !persona.vac_pendientes}" v-if="canViewOtherInfoMyTeam">
                  <a-icon type="clock-circle" theme="twoTone" two-tone-color="#1890ff"/>
                  Vacaciones Pendientes: {{ persona.vac_pendientes }}
                </p>
                <p :class="{'hidden-info': !persona.vac_aprobadas}" v-if="canViewOtherInfoMyTeam">
                  <a-icon type="check-circle" theme="twoTone" two-tone-color="#1890ff"/>
                  Vacaciones Aprobadas: {{ persona.vac_aprobadas }}
                </p>
                <p :class="{'hidden-info': !persona.total_vaca_pendientes}" v-if="canViewOtherInfoMyTeam">
                  <a-icon type="calendar" theme="twoTone" two-tone-color="#faad14"/>
                  Total de Vacaciones: {{ persona.total_vaca_pendientes }}
                </p>
                <a-divider></a-divider>
                <p :class="{'hidden-info': !persona.en_vacacion}" v-if="canViewOtherInfoMyTeam">
                  <a-icon type="smile" theme="twoTone" two-tone-color="#52c41a"/>
                  En vacaciones: {{ persona.en_vacacion }}
                </p>
                <p :class="{'hidden-info': !persona.de_cumpleanos}" v-if="canViewOtherInfoMyTeam">
                  <a-icon type="gift" theme="twoTone" two-tone-color="#faad14"/>
                  De Cumpleaños
                </p>
                <p :class="{'hidden-info': !persona.incapacitado}" v-if="canViewOtherInfoMyTeam">
                  <a-icon type="medicine-box" theme="twoTone" two-tone-color="#ff4d4f"/>
                  Incapacitado: {{ persona.incapacitado }}
                </p>
              </div>
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
    </a-spin>
  </a-modal>
</template>
<script>
  import FLAGS from 'CustomModules/GlobalBPOCore/Util/FlagsUtil'
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from '../../../GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        personas: [],
        loading: false,
        jefe: {},
        profileSrc: require('CustomModules/GlobalBPOCore/assets/anon_profile.png'),
        profiles: {},
        profileLoading: {},
        jefeLoading: true,
        flags: FLAGS,
        canViewOtherInfoMyTeam: this.$getConfigValue('VER_NUEVA_INFO_MODAL_MY_TEAM', 'SI') === 'SI'
      }
    },
    props: ['visible'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.cargarPersonas()
    },
    methods: {
      cargarPersonas () {
        this.loading = true
        this.httpClient.getInstance().get('ss/dashboard/my_team/consulta_team')
          .then(response => {
            this.personas = response.data
            this.loadProfilePictures()
            this.loading = false
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar la información.')
          })

        this.httpClient.getInstance().get('ss/dashboard/my_team/consulta_jefe')
          .then(response => {
            this.jefe = response.data
            this.loadProfileSrc(this.jefe, () => {
              this.jefeLoading = false
              this.loading = false
            })
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar la información del jefe.')
          })
      },
      close () {
        this.$emit('ok')
      },
      loadProfilePictures () {
        let loadPic = (index) => {
          if (this.personas.length > index) {
            let p = this.personas[index]
            p.loading = true
            this.loadProfileSrc(p,
              () => {
                p.loading = false
                this.$forceUpdate()
                loadPic(index + 1)
              })
          }
        }

        loadPic(0)
      },
      loadProfileSrc (persona, callback) {
        this.httpClient.getInstance().get('picture_service/render/profile/' + persona.id_person, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profiles[persona.id_person] = window.URL.createObjectURL(blob)
          })
          .catch(() => {
            this.profiles[persona.id_person] = this.profileSrc
          })
          .then(callback)
      }
    },
    computed: {
      showJefe () {
        return !JsUtils.isEmpty(this.jefe)
      }
    }
  }
</script>
<style scoped>
  .fixed-card {
    min-height: 180px; /* Ajusta según necesidad */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .card-content p {
    margin: 4px 0; /* Espaciado uniforme */
    min-height: 22px; /* Reserva espacio aunque no haya info */
  }

  /* Ocultar sin eliminar el espacio reservado */
  .hidden-info {
    visibility: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/ModalMyTeam.vue